import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import axios from "axios";
import Notify from 'quasar/src/plugins/Notify.js';;
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
export default (function (_ref) {
  var store = _ref.store,
      router = _ref.router;
  // Add a response interceptor to Axios
  axios.interceptors.response.use(undefined, function (error) {
    var _error$response = error.response,
        data = _error$response.data,
        status = _error$response.status,
        config = _error$response.config; // Check if the response status is 401 (unauthorized) or 419 (CSRF token expired)

    if (error.response.status === 401 && config && !config.__isRetryRequest) {
      // If the response status is 401 or 419, dispatch a logout action to the Vuex store's Auth module
      LocalStorage.set('loggedIn', false);
      store.dispatch('resetAll');
      router.push('/auth');
    }

    switch (status) {
      case 401:
        Notify.create({
          message: 'Unauthorized',
          badgeClass: 'invisible'
        });
        break;

      case 403:
        Notify.create('forbidden');
        break;

      case 500:
        // redirect to error 500 page
        router.push({
          name: 'error500'
        });
        break;
    } // Return a rejected Promise with the error


    return Promise.reject(error);
  });
});